<template>
  <div :class="{ [`size${size}`]: size }" class="favButton">
    <div class="bookmarkButton" @click="toggleBookmark">
      <icon :class="{ active: isBookmarked }" fas="fa-star" class="favButton-star" />
      <div v-if="displayLabel" :class="{ active: isBookmarked }" class="favButton-label">気になる</div>
      <div v-if="canDisplayBookmarkedCount" :class="{ active: isBookmarked }" class="favButton-count">{{ bookmarkedUserCount }}</div>
    </div>
  </div>
</template>

<script>
import BookmarkEventMixin from '@/utils/mixins/BookmarkEventMixin'
const DISPLAY_BOOKMARKED_COUNT = 5
export default {
  mixins: [BookmarkEventMixin],
  props: {
    size: { type: Number, required: false, default: 32 },
    displayLabel: { type: Boolean, required: false, default: false },
    hideCount: { type: Boolean, required: false, default: true },
    bookmarkedUserCount: { type: Number, required: false, default: 0 }
  },
  computed: {
    canDisplayBookmarkedCount() {
      return !this.hideCount && this.bookmarkedUserCount >= DISPLAY_BOOKMARKED_COUNT
    }
  }
}
</script>

<style lang="scss" scoped>
.favButton {
  @include flex;
  text-align: center;
  height: fit-content !important;
  .bookmarkButton {
    @include flex;
    flex-direction: column;
    text-align: center;
    cursor: pointer;
  }
  &.size32 {
    width: 32px;
    height: 32px;
  }
  &.size60 {
    width: 60px;
    height: 60px;
  }
  &.size70 {
    width: 70px;
    height: 70px;
  }
  &-star {
    color: $gray-80;
    line-height: 100%;
    &.active {
      color: $yellow;
    }
  }
  &.size32 &-star {
    font-size: 2.5rem;
    margin-bottom: 1px;
  }
  &.size60 &-star {
    font-size: 4.2rem;
  }
  &.size70 &-star {
    font-size: 2.1rem;
  }
  &-label {
    color: $gray-55;
    font-size: 1rem;
    font-weight: 700;
    &.active {
      color: $yellow;
    }
  }
  &-count {
    color: $gray-80;
    font-size: 1.2rem;
    font-weight: bold;
    &.active {
      color: $yellow;
    }
  }
}
</style>
